export default __webpack_public_path__ + "static/media/free.56bf42c4.png";